import { Select, SelectProps } from "antd";
import React from "react";

const CivilLookupTypeDropdown = ({ ...props }: Partial<SelectProps>) => {
  return (
    <Select {...props}>
      <Select.Option value="PLAINTIFF">Plaintiff</Select.Option>
      <Select.Option value="DEFENDANT">Defendant</Select.Option>
      <Select.Option value="CASENUMBER">Case Number</Select.Option>
    </Select>
  );
};

export default CivilLookupTypeDropdown;
